<template>
  <CCard>
    <CCardBody class="mb-3">
      <CCardHeader>
        <CRow>
          <CCol col="8" style="text-align: start">

            <strong>{{ $t('sidebars.chequeList') }}</strong>

          </CCol>
          <CCol col="4" style="text-align: end">

          </CCol>
        </CRow>
        <!--        </div>-->

        <!-- Right aligned nav items -->
        <!--      </CCollapse>-->
      </CCardHeader>
      <CRow>
        <CCol col="3">
          <date-picker
              :label="$t('components.startDate')"
              v-model="start_date"></date-picker>
        </CCol>
        <CCol col="3">
          <date-picker
              :label="$t('components.endDate')"
              v-model="end_date"></date-picker>

        </CCol>
        <CCol col="1">
          <CButton @click="get_receive_list()" color="dark"
                   size="sm">
            <CIcon size="sm" name="cil-zoom"/>
          </CButton>
        </CCol>
      </CRow>
      <CRow>
        <CCol col="3">
          <CSelect
              :label="$t('tables.status')"
              :value.sync="status_filter"
              horizontal
              :options="[{label:$t('all'),value:-1},{label:$t('noStatus'),value:0},...change_status_statuses]"
          />
        </CCol>
      </CRow>
      <CDataTableFixed
          :items="status_filter==-1 ? items : items.filter(x=>x.lastStatusId == status_filter)"
          :fields="fields"
          striped
          border
          @row-clicked="table_row_clicked"

          column-filter
          :items-per-page="200"
          hover
          sorter
          pagination
      >


        <template #row="{item,index}">

          <td style="text-align: center">
            <p>{{ index + 1 }}</p>

          </td>

        </template>
        <template #docDate="{item}">
          <td>
            <p style="text-align: center;">{{ get_date(item.docDate) }}</p>
          </td>
        </template>
<!--        <template #lastStatusSummary="{item}">-->
<!--          <td>-->
<!--            <p v-if="item.lastStatusSummary!=null">{{ (item.lastStatusSummary) }}</p>-->
<!--          </td>-->
<!--        </template>-->
        <template #docNoCode="{item}">
          <td>
            <p style="text-align: center">
              <a :href="'/dashboard/accounting/show-accounting-doc/'+item.docNo" target="_blank">
                {{ item.docNoCode }}
              </a>
            </p>
          </td>
        </template>
        <template #price="{item}">
          <td>
            <p style="float: right">{{ get_currency(parseFloat(item.price)) }}</p>
          </td>
        </template>
        <template #sarRecidDate="{item}">
          <td>
            <p  style="text-align: center;">{{ get_date((item.sarRecidDate)) }}</p>
          </td>
        </template>
        <template #serial="{item}">
          <td>
            <p  style="text-align: center;">{{ item.serial }}</p>
          </td>
        </template>
        <template #bankName="{item}">
          <td>
            <p  style="text-align: center;">{{ item.bankName }}</p>
          </td>
        </template>
        <template #payDesc="{item}">
          <td>
            <p v-if="item.payDesc!=null">{{ item.payDesc }}</p>
          </td>
        </template>
        <template #masterCode="{item}">
          <td>
            <p v-if="item.masterCode!=null">{{ item.masterCode }}</p>
          </td>
        </template>

        <template #lastStatus="{item}">
          <td>
            <p  style="text-align: center;padding:3px;font-size: 11px;" class="text-danger"
               @click="open_change_status_cheque(item)">{{ item.lastStatus }}</p>
            <p v-if="item.lastStatusSummary!=null">{{ (item.lastStatusSummary) }}</p>

          </td>
        </template>
        <template #caption="{item}">
          <tr class="total-table">

            <td></td>
            <td></td>
            <td></td>
            <td></td>

            <td>
              {{ $t('totalSum') }}
            </td>
            <td>
              {{ get_currency(calculate_items(items.filter(x => x.lastStatusId == 0), "price")) }}

            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </template>

      </CDataTableFixed>


    </CCardBody>
    <CModal
        :show.sync="change_status_dialog"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"

        :title="$t('components.changeStatus')"
    >
      <CRow v-if="change_status_item.partyName!=null">
        <CCol col="12" style="font-weight: bold;margin-bottom: 5px">{{ $t('tables.customer') }} :
          {{ change_status_item.partyName }}
        </CCol>
        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('tables.amount') }} :
          {{ get_currency(change_status_item.price) }}
        </CCol>

        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('bankName') }} :
          {{ change_status_item.bankName }}
        </CCol>
        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('components.passDate') }} :
          {{ get_date(change_status_item.sarRecidDate) }}
        </CCol>

        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('SortCode') }} :
          {{ (change_status_item.sortCode) }}
        </CCol>
        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('chequeNumber') }} :
          {{ change_status_item.serial }}
        </CCol>

        <CCol col="6" style="font-weight: bold;margin-bottom: 5px">{{ $t('AccountNo') }} :
          {{ change_status_item.bankAccount }}
        </CCol>


      </CRow>
      <CRow>
        <CCol col="12">

          <CRow form class="form-group">
            <label tag="label" sm="12" class="col-form-label">
              {{ $t('docDate') }}
            </label>
            <CCol sm="12">
              <date-picker
                  v-model="doc_date"
                  :min="get_min_doc_date()"
                  :max="get_max_doc_date()"
              ></date-picker>
            </CCol>
          </CRow>
          <CSelect
              :label="$t('tables.status')"
              :value.sync="change_status_selected_status"
              :options="cheque_statuses_filter"
          />

          <CSelect
              v-if="change_status_selected_status==1 || change_status_selected_status==6"
              :label="$t('tables.bank')"
              :value.sync="selected_bank"
              :options="banks"
          />
          <CSelect
              v-if="change_status_selected_status==2"

              :label="$t('components.cash')"
              :value.sync="selected_cashier"
              :options="cashiers"
          />
          <CSelect
              :options="moeins_kharj"
              v-if="change_status_selected_status==5"
              :value.sync="selected_moein_kharj"
          />
          <treeselect
              v-model="refer_person"
              v-if="change_status_selected_status==5"
              @select="get_person_remaining_amount"

              :async="true"
              :load-options="load_persons"
              :placeholder="$t('components.searchUser')"
              :normalizer="normalizer_persons"
          />
<div v-if="change_status_selected_status==5">
  {{ $t('tables.balance') }} : {{ get_currency(remaining) }}
</div>
          <CInput
              :label="$t('tables.summary')"
              v-model="change_status_desc"
          />


        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_cheque_status_confirm()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_status_dialog = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
    <CModal
        :show.sync="cheque_status_dialog"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"

        :title="$t('components.changeStatus')"
    >

      <CDataTableFixed
          :items="cheque_status_items"
          :fields="cheque_status_fields"
          striped
          border

          column-filter
          :items-per-page="200"
          hover
          sorter
          pagination
      >


        <template #row="{item,index}">

          <td style="text-align: center">
            <p>{{ index + 1 }}</p>

          </td>

        </template>
        <template #createdAt="{item}">
          <td>
            <p>{{ get_date(item.createdAt) }}</p>
          </td>
        </template>

      </CDataTableFixed>

      <template #footer>

        <CButton
            @click="cheque_status_dialog = false"
            color="danger"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'ReceiveOperation',

  components: {
    Treeselect,
    BTabs,
  },

  data() {
    var self = this;

    return {
      remaining:"0",
      cheque_status_dialog: false,
      cheque_status_items: [],
      status_filter: 0,
      cheque_status_fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'createdAt', label: this.$t('date'), _style: 'padding:0px'},

        {key: 'createdBy', label: this.$t('user'), _style: 'padding:0px'},
        {key: 'accountName', label: this.$t('AccountName'), _style: 'padding:0px'},
        {key: 'recSummary', label: this.$t('tables.summary'), _style: 'padding:0px'},
        {key: 'tafsiliName', label: this.$t('tafsiliTitle'), _style: 'padding:0px'},

      ],
      table_clicks: 0,
      table_clicks_timer: null,
      moeins_kharj: [
        {value: 0, label: this.$t('select')},
        {value: 163, label: this.$t('Suppliers')},
        {value: 80, label: this.$t('Customers')},
      ],
      selected_moein_kharj: 0,
      start_date: '',
      end_date: '',
      doc_date: '',
      selected_master_type: 130,
      search_reference_master: 0,
      selected_doc_type: 2,
      selected_receiver_cash: 0,
      document_person_cash: null,
      refer_person: null,
      change_status_dialog: false,
      change_status_item: {},
      change_status_desc: '',
      change_status_selected_status: 1,
      change_status_statuses: [],


      searched_refrences: [],
      get_items: [1],
      master_id: null,
      master_types: [{id: 130, label: this.$t('Customers')}, {id: 132, label: this.$t('debtors')}, {
        id: 142,
        label: this.$t('persons')
      }, {id: 141, label: this.$t('FlowEmployee')}, {id: 140, label: this.$t('EmployeeLoans')}],
      active_tab: 0,
      date_cash: '',
      summary: '',
      cashiers: [],
      banks: [],
      terminals: [],
      selected_bank: 0,
      selected_cashier: 0,
      selected_payer_cash: null,
      doc_types: [
        {value: 2, label: this.$t('components.cash')},
        {
          value: 6, label: this.$t('components.bank')
        }, {value: 1, label: this.$t('components.pos')}],
      status_form: 0,
      price: '',
      bank_names: [],
      searched_person: [],
      document_person: null,
      search_user_async: true,
      pay_for_detail: null,
      // search_detail_async

      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'docDate', label: this.$t('date'), _style: 'padding:0px'},

        {key: 'docNoCode', label: this.$t('docNumber'), _style: 'padding:0px'},
        {key: 'partyName', label: this.$t('tables.customer'), _style: 'width:20%;padding:0px'},
        {key: 'masterCode', label: this.$t('reference'), _style: 'padding:0px'},

        {key: 'price', label: this.$t('tables.amount'), _style: 'padding:0px'},

        // {key: 'payerId', label: this.$t('tables.receiver'), _style: 'padding:0px'},
        {key: 'sarRecidDate', label: this.$t('components.passDate'), _style: 'width:12%;padding:0px'},
        {key: 'serial', label: this.$t('chequeNumber'), _style: 'width:10%;padding:0px'},
        {key: 'bankName', label: this.$t('bankName'), _style: 'width:10%;padding:0px'},
        // {key: 'bankAccount', label: this.$t('AccountNo'), _style: 'width:10%;padding:0px'},
        // {key: 'lastStatusSummary', label: this.$t('tables.summary'), _style: 'padding:0px;text-align:center'},
        {key: 'lastStatus', label: this.$t('tables.status'), _style: 'padding:0px;text-align:center'},

        // {key: 'paymentTypeTitle', label: this.$t('tables.payType'), _style: 'padding:0px'},
        // {key: 'payDesc', label: this.$t('description'), _style: 'padding:0px'},
      ],
      items: [],


      document_person_cheque: null,
      selected_receiver_cheque: null,
      summary_cheque: "",
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  }, mounted() {
    this.date_cash = this.get_today();
    this.date_cheque = this.get_today();
    this.doc_date = this.get_today();
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
    this.get_banks();
    this.get_cashiers();

    this.get_receive_list();
    this.get_receive_status();
    bus.$on("update_add_receive", (data) => {
      // alert(data);
      this.get_receive_list();

    });
    bus.$on(this.confirm_delete_name + "add_status", (data) => {
      // alert(data);
      this.change_status_dialog = true

      if (data == "true") {
        this.change_cheque_status();
      }
    });
    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  }, watch: {
    // 'start_date': function () {
    //   this.get_receive_list();
    // },
    // 'end_date': function () {
    //   this.get_receive_list();
    // }
  },
  computed: {
    cheque_statuses_filter(){
       let filtered_status = this.change_status_statuses
      if(this.change_status_item.lastStatusId==5){
        filtered_status = this.change_status_statuses.filter(x=>x.value==3)
      }else{
        filtered_status = this.change_status_statuses.filter(x=>x.value!=3)

      }
      return [{label:this.$t('select'),value:0},...filtered_status]
      // lastStatusId
      // change_status_item
      // return filtered_status
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        this.table_clicks = 0

        clearTimeout(this.table_clicks_timer);
        this.cheque_status_list(item.id)
      }

    },
    get_person_remaining_amount(node) {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      var url = ""
        url = "GetLastPartyAccountByParam"



      if (this.moeins_kharj == 80) {//customers
        formData.append('TafsiliType', 2);
      } else if (this.moeins_kharj == 163) {//suppliers
        formData.append('TafsiliType', 3);
      } else if (this.moeins_kharj == 70) {
        formData.append('TafsiliType', 6);
      } else if (this.moeins_kharj == 288) {
        formData.append('TafsiliType', 7);
      } else {
        formData.append('TafsiliType', 5);
      }

      formData.append('id', 0);


      formData.append('PartyId', node.userId);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.remaining =  response.data.data.balance

          // response.data.data.balance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

// 222800 16 3 26 4
    change_cheque_status_confirm() {
      if(this.change_status_selected_status==6){
        this.change_status_desc =this.change_status_desc + " "+this.banks.filter(x=>x.value==this.selected_bank)[0].label
      }

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToConfirm"), [this.$t("dialogs.ok")], this.confirm_delete_name + "add_status");
      this.change_status_dialog = false
    },
    change_cheque_status() {
      var self = this;

      const formData = new FormData();
console.log("change cheque status", this.change_status_item)

      formData.append('docDate', this.doc_date);
      formData.append('ChequeId', this.change_status_item.id);
      if (this.change_status_selected_status == 2) {//cash
        formData.append('TafsiliId', this.selected_cashier);
        formData.append('AccountId', this.cashiers.filter(x => x.id == this.selected_cashier)[0].accountId);
      }
      if (this.change_status_selected_status == 1) {//bank
        formData.append('TafsiliId', this.selected_bank);
        formData.append('AccountId', this.banks.filter(x => x.id == this.selected_bank)[0].accountId);

      }
      if (this.change_status_selected_status == 5) {//kharj cheque
        if (this.selected_moein_kharj == 0) {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), {error: 1, msg: "نوع را مشخص کنید"});

          return false
        }
        formData.append('PersonId', this.refer_person);
        formData.append('AccountId', this.selected_moein_kharj);

      }
      formData.append('StatusId', this.change_status_selected_status);
      formData.append('RecSummary', this.change_status_desc);
      this.change_status_dialog = false;


      axios.post('AddReceiverChequeStatus', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.get_receive_list();
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    cheque_status_list(id) {
      var self = this;

      const formData = new FormData();


      formData.append('ChequeId', id);

      this.cheque_status_dialog = true;


      axios.post('GetReceiverChequeStatusRptList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cheque_status_items = response.data.data
          self.cheque_status_dialog = true;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    open_change_status_cheque(item) {
      const disable_statuses = [1,2,4]
      if(disable_statuses.includes(item.lastStatusId)){
        return false
      }
      this.change_status_selected_status = 0
      this.change_status_item = item;
      this.change_status_dialog = true;

    },
    get_receive_status() {
      var self = this;

      const formData = new FormData();


      axios.post('GetReceiverChequeStatusList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          // self.change_status_statuses = self.sort_array([], content_data.data, "id", "title")
          content_data.data.forEach(function (val) {
            val.label = val.title
            val.value = val.id
          })
          self.change_status_statuses = content_data.data
          // self.change_status_statuses = self.change_status_statuses.sort((a, b) => a.value.localeCompare(b.value, undefined, {numeric: true, sensitivity: 'base'}));

          self.change_status_selected_status = self.change_status_statuses[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_receive_list() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);


      axios.post('GetReceiverCheques', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data;

          self.items = self.items.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.banks = self.sort_array([], content_data.data, 'id', 'bankAccTitle')
          self.selected_bank = self.banks[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = self.sort_array(
              self.cashiers, response.data.data.filter(x => x.accountId == 70),
              'id', 'boxTitle');
          self.selected_cashier = self.cashiers[0].value
          self.get_terminals();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_terminals() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.terminals = content_data.data;
          self.cashiers = self.sort_array(
              self.cashiers, response.data.data,
              'id', 'terminalTitle');
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
